export { AngularMultiSelect } from './angular2-multiselect-dropdown/multiselect.component';
export { ClickOutsideDirective } from './angular2-multiselect-dropdown/clickOutside';
export { ListFilterPipe } from './angular2-multiselect-dropdown/list-filter';
export { groupByPipe } from './angular2-multiselect-dropdown/group-by';
export { AngularMultiSelectModule } from './angular2-multiselect-dropdown/multiselect.component';
//# sourceMappingURL=angular2-multiselect-dropdown.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-multiselect-dropdown/angular2-multiselect-dropdown.js
// module id = 546
// module chunks = 3